// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2K8l9","col":"CardReaderDesc_col__3OTCZ","label":"CardReaderDesc_label__3QnJv"};